<div *ngIf="!showFormTabs">
  <mat-card appearance="outlined">
    <mat-card-title style="margin: 15px;">
      Search Employee
    </mat-card-title>
    <mat-card-content>
      <div class="search-container">
        <form [formGroup]="requestForm">
          <div class="search-section">
            <mat-form-field appearance="outline">
              <mat-label>Employee Name</mat-label>
              <input matInput formControlName="employeeName" placeholder="Employee Name" />
            </mat-form-field>
            
            <!-- <mat-form-field appearance="outline">
                          <mat-label>Employee Department</mat-label>
                          <input matInput formControlName="employeeDepartment" placeholder="Employee Department" />
                        </mat-form-field> -->
            <mat-form-field appearance="outline">
              <mat-label>Employee Department</mat-label>
              <mat-select formControlName="employeeDepartment" placeholder=" Employee Department">
                <mat-option *ngFor="let department of departments" [value]="department.code">
                  {{ department.value }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="employeeDetailsForm.get('department')?.hasError('required')">
                Department is required.
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Mobile Number</mat-label>
              <input matInput formControlName="mobileNumber" placeholder="Mobile Number" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Employee Trade</mat-label>
              <input matInput formControlName="employeeTrade" placeholder="Employee Trade" />
            </mat-form-field>
          </div>
        </form>

        <div class="buttons">
          <button mat-flat-button color="primary" (click)="searchEmployee()">Search</button>
          <button mat-stroked-button color="warn" (click)="requestForm.reset()">Reset</button>
          <button mat-flat-button color="primary" type="button" (click)="onCreateNewUser()">
            <mat-icon>person_add</mat-icon>
            Create New Employee
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>

  <div style="margin-top: 25px; margin-bottom: 20px;" *ngIf="!showFormTabs">
    <mat-card appearance="outlined">
      <mat-card-title style="margin: 15px;">Employee List</mat-card-title>
      <mat-card-content>
        <div class="table-container">
          <!-- Loading Spinner -->
          <div *ngIf="isLoading" class="loading-container">
            <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
          </div>

          <!-- Table with Data -->
          <div *ngIf="dataSource.data.length > 0; else noEmployeesTemplate">
            <table mat-table [dataSource]="dataSource" class="mat-table" *ngIf="!isLoading">

              <!-- Rank Column -->
              <!-- <ng-container matColumnDef="rank">
              <th mat-header-cell *matHeaderCellDef> Rank </th>
              <td mat-cell *matCellDef="let element"> {{element.rank}} </td>
            </ng-container> -->

              <!-- Employee Name Column -->
              <ng-container matColumnDef="employeeName">
                <th mat-header-cell *matHeaderCellDef> Employee Name </th>
                <td mat-cell *matCellDef="let element">{{element.rank}} {{element.employeeName}} </td>
              </ng-container>

              <!-- Trade Column -->
              <ng-container matColumnDef="trade">
                <th mat-header-cell *matHeaderCellDef> Trade </th>
                <td mat-cell *matCellDef="let element"> {{element.trade}} </td>
              </ng-container>

              <!-- Mobile Column -->
              <ng-container matColumnDef="mobile">
                <th mat-header-cell *matHeaderCellDef> Mobile </th>
                <td mat-cell *matCellDef="let element"> {{element.mobile}} </td>
              </ng-container>

              <!-- Email Column -->
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef> Email </th>
                <td mat-cell *matCellDef="let element"> {{element.email}} </td>
              </ng-container>

              <!-- User Name Column -->
              <ng-container matColumnDef="userName">
                <th mat-header-cell *matHeaderCellDef> User Name </th>
                <td mat-cell *matCellDef="let element"> {{element.userName}} </td>
              </ng-container>

              <!-- Actions Column -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> Actions </th>
                <td mat-cell *matCellDef="let element">
                  <button mat-icon-button [matMenuTriggerFor]="menu">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="basicInfo(element,'employeeDetails')">
                      <mat-icon>info</mat-icon>
                      <span>Employee Details</span>
                    </button>
                    <button mat-menu-item (click)="basicInfo(element,'manageLocation')">
                      <mat-icon>location_on</mat-icon>
                      <span>Manage Location</span>
                    </button>
                    <button mat-menu-item (click)="basicInfo(element,'manageLogin')">
                      <mat-icon>login</mat-icon>
                      <span>Manage Login</span>
                    </button>
                    <button mat-menu-item *ngIf="canManageAreasForEmployee(element)"
                      (click)="basicInfo(element,'manageAreas')">
                      <mat-icon>map</mat-icon>
                      <span>Manage Areas</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <!-- Rows -->
              <tr mat-header-row *matHeaderRowDef="employeeDetailsColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: employeeDetailsColumns;"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="7">No data matching the filter</td>
              </tr>
            </table>
          </div>
          <!-- Paginator -->
          <mat-paginator [length]="dataSource.data.length" [pageSize]="5" [pageSizeOptions]="[5, 10, 20]"
            showFirstLastButtons> </mat-paginator>

        </div>

        <!-- No Employees Template -->
        <ng-template #noEmployeesTemplate>
          <div class="no-data-message">
            <mat-icon>group</mat-icon>
            <p>No employees found.</p>
          </div>
        </ng-template>
      </mat-card-content>
    </mat-card>

  </div>


<mat-card appearance="outlined" [hidden]="!showFormTabs">
<div class="card-title-with-action">
    <mat-card-title style="margin: 15px; display: flex; align-items: center;">
      {{ preFilled ? 'Edit Employee' : 'Create New Employee' }}

      <span 
        *ngIf="!preFilled && isRegisteringNewEmployee" 
        style="font-size: 14px; font-weight: normal; margin-left: 10px; color: #666;">
        to transfer {{ employeeDetails?.firstName }} {{ employeeDetails?.lastName }} responsibilities
      </span>
      </mat-card-title>
    <div class="card-actions" *ngIf="preFilled">
      <button mat-flat-button color="primary" (click)="onEndEmployee()">
        <mat-icon>exit_to_app</mat-icon>
        End Employee
      </button>
    </div>
  </div>
  <mat-card-content>
    <mat-tab-group #tabGroup [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">


      <!-- Employee Details Tab -->
      <mat-tab label="Employee Details">
        <form [formGroup]="employeeDetailsForm">
          <div class="form-section">
            <h6 style="margin-top: 15px;">Basic Information</h6>
            <div class="form-grid">

              <mat-form-field appearance="outline">
                <mat-label>Rank</mat-label>
                <input matInput formControlName="rank" placeholder="Rank">
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Designation</mat-label>
                <input matInput formControlName="designation" placeholder="Designation">
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>First Name</mat-label>
                <input matInput formControlName="firstName" placeholder="First Name">
                <mat-error *ngIf="employeeDetailsForm.get('firstName')?.hasError('required')">
                  First name is required.
                </mat-error>
                <mat-error *ngIf="employeeDetailsForm.get('firstName')?.hasError('minlength')">
                  First name must be at least 2 characters.
                </mat-error>
                <mat-error *ngIf="employeeDetailsForm.get('firstName')?.hasError('invalidChars')">
                  First name can only contain letters and spaces.
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Last Name</mat-label>
                <input matInput formControlName="lastName" placeholder="Last Name">
                <mat-error *ngIf="employeeDetailsForm.get('lastName')?.hasError('invalidChars')">
                  Last name can only contain letters and spaces.
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Trade</mat-label>
                <input matInput formControlName="trade" placeholder="Trade">
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Mobile Number</mat-label>
                <input matInput formControlName="mobileNo" maxlength="10" placeholder="9876543210">
                <mat-error *ngIf="employeeDetailsForm.get('mobileNo')?.hasError('required')">Mobile number is
                  required.</mat-error>
                <mat-error *ngIf="employeeDetailsForm.get('mobileNo')?.hasError('pattern')">
                  Please enter a valid 10-digit mobile number.
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Email</mat-label>
                <input matInput formControlName="email" type="email" placeholder="name@example.com">
                <mat-error *ngIf="employeeDetailsForm.get('email')?.hasError('required')">Email is
                  required.</mat-error>
                <mat-error *ngIf="employeeDetailsForm.get('email')?.hasError('pattern')">
                  Please enter a valid email address.
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Official Number</mat-label>
                <input matInput formControlName="officialNo" maxlength="10" placeholder="Official Number">
                  <mat-error *ngIf="employeeDetailsForm.get('officialNo')?.hasError('pattern')">
                  Must be a valid 10-digit number.
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Department</mat-label>
                <mat-select formControlName="department" placeholder="Department">
                  <mat-option *ngFor="let department of departments" [value]="department.code">
                    {{ department.value }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="employeeDetailsForm.get('department')?.hasError('required')">
                  Department is required.
                </mat-error>
              </mat-form-field>


              <!-- <mat-checkbox formControlName="receiveSMS" color="primary">Receive SMS</mat-checkbox>
            <mat-checkbox formControlName="receiveEmail" color="primary">Receive Email</mat-checkbox> -->

              <div class="communication-preferences">
                <h6>Communication Preferences</h6>
                <mat-checkbox formControlName="receiveEmail" color="primary">Allow Email Communication</mat-checkbox>
                <mat-checkbox formControlName="receiveSMS" color="primary">Allow SMS Communication</mat-checkbox>
              </div>


            </div>
          </div>
        </form>
      </mat-tab>


      <!-- Manage location Tab -->
      <mat-tab label="Living Location">
          <div>
            <h6 style="margin-top: 15px;">Locations Details</h6>
            <div style="text-align: right;">
              <button mat-flat-button color="primary" (click)="openLocationPopup()">
                <mat-icon>search</mat-icon> Find and Add Location
              </button>
            </div>
            <div class="table-container">
              <table mat-table [dataSource]="assignedLocations" class="mat-table">
                <ng-container matColumnDef="areaName">
                  <th mat-header-cell *matHeaderCellDef> Area Name </th>
                  <td mat-cell *matCellDef="let element"> {{element.areaName}} </td>
                </ng-container>
                <ng-container matColumnDef="QuarterNo">
                  <th mat-header-cell *matHeaderCellDef> Quarter No </th>
                  <td mat-cell *matCellDef="let element"> {{element.quarterNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="blockNumber">
                  <th mat-header-cell *matHeaderCellDef> Block Number </th>
                  <td mat-cell *matCellDef="let element"> {{element.blockNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="locationName">
                  <th mat-header-cell *matHeaderCellDef> Location Name </th>
                  <td mat-cell *matCellDef="let element"> {{element.locationName}} </td>
                </ng-container>
                <ng-container matColumnDef="locationAssignedTo">
                  <th mat-header-cell *matHeaderCellDef> Location Assigned to </th>
                  <td mat-cell *matCellDef="let element"> {{element.locationAssignedTo}} </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef> Actions </th>
                  <td mat-cell *matCellDef="let element">
                    <button mat-icon-button color="warn" (click)="removeLocation(element.id)"
                      *ngIf="element.status !== 'Deleted'">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef>Status</th>
                  <td mat-cell *matCellDef="let element" [ngClass]="{
                    'status-assigned': element.status === 'Assigned',
                    'status-deleted': element.status === 'Deleted',
                    'status-new': element.status === 'Newly Added'
                  }">
                    {{ element.status }}
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="7">No locations assigned yet.</td>
                </tr>
              </table>
            </div>
          </div>
        </mat-tab>

      <mat-tab label="Area Access" *ngIf="canManageLonavalaAreaAccess">
        <section class="area-access-section">
          <p *ngIf="!areaAccessAppliesToCurrentEmployee" class="no-data-message">
            No employee login is linked. Area access can be assigned after a login is linked to this employee.
          </p>
          <ng-container *ngIf="areaAccessAppliesToCurrentEmployee">
          <div class="area-access-header">
            <div>
              <h6>Lonavala Area Access</h6>
              <p>Choose the areas this employee can access.</p>
            </div>
            <div class="area-access-count" aria-live="polite">
              {{ selectedAreaIds.size }} of {{ lonavalaAreaOptions.length }} selected
            </div>
          </div>

          <div class="area-access-filters">
            <mat-form-field appearance="outline">
              <mat-label>Search areas</mat-label>
              <input matInput [(ngModel)]="areaAccessSearch" [ngModelOptions]="{ standalone: true }">
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Assignment</mat-label>
              <mat-select [(ngModel)]="areaAccessFilter" [ngModelOptions]="{ standalone: true }">
                <mat-option value="ALL">All areas</mat-option>
                <mat-option value="ASSIGNED">Assigned</mat-option>
                <mat-option value="UNASSIGNED">Not assigned</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="area-access-actions">
            <button mat-button type="button" (click)="setVisibleAreasSelected(true)">Select visible</button>
            <button mat-button type="button" (click)="setVisibleAreasSelected(false)">Clear visible</button>
          </div>

          <div class="loading-container" *ngIf="areaAccessLoading">
            <mat-spinner diameter="32"></mat-spinner>
          </div>
          <p class="area-access-error" role="alert" *ngIf="areaAccessError">{{ areaAccessError }}</p>
          <div class="area-access-list" *ngIf="!areaAccessLoading && !areaAccessError">
            <mat-checkbox *ngFor="let area of filteredLonavalaAreas"
              color="primary"
              [checked]="isAreaSelected(area.code)"
              (change)="setAreaSelected(area.code, $event.checked)">
              {{ area.value }}
            </mat-checkbox>
            <p class="no-data-message" *ngIf="filteredLonavalaAreas.length === 0">No areas match these filters.</p>
          </div>
          </ng-container>
        </section>
      </mat-tab>

      <!-- Manage Login Tab -->
      <mat-tab label="Manage Login">
        <form [formGroup]="loginForm">
          <div class="form-section">
            <h6 style="margin-top: 15px;">Login Details</h6>
            <div class="form-grid">

              <!-- <mat-form-field appearance="outline">
                <mat-label>Username</mat-label>
                <input matInput formControlName="userName" required>
                <mat-error *ngIf="loginForm.get('userName')?.hasError('required')">
                  Username is required.
                </mat-error>
              </mat-form-field> -->

                <mat-form-field appearance="outline">
                <mat-label>User Name</mat-label>
                <input matInput formControlName="userName" required>
                <mat-error *ngIf="loginForm.get('userName')?.hasError('required') && loginForm.get('userName')?.touched">
                  User name is required.
                </mat-error>
                <mat-error *ngIf="loginForm.get('userName')?.hasError('minlength')">
                  Must be at least 5 characters.
                </mat-error>
                <mat-error *ngIf="loginForm.get('userName')?.hasError('maxlength')">
                  Cannot exceed 12 characters.
                </mat-error>
                <mat-error *ngIf="loginForm.get('userName')?.hasError('pattern')">
                  Username can only contain letters, numbers, &#64;, ., or _.
                </mat-error>
                 <mat-error *ngIf="loginForm.get('userName')?.hasError('usernameExists')">
                   Username already exists. Please choose a different username.
                 </mat-error>
              </mat-form-field>

              <!-- <mat-form-field appearance="outline">
                <mat-label>Password</mat-label>
                <input matInput formControlName="password" [type]="hidePassword ? 'password' : 'text'">
                <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button">
                  <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
              </mat-form-field> -->

                  <mat-form-field appearance="outline">
                <mat-label>Password</mat-label>
                <input matInput formControlName="password" [type]="hidePassword ? 'password' : 'text'" spellcheck="false"
                  (copy)="false" (cut)="false" (paste)="false" autocorrect="off">
                <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword">
                  <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
                  <mat-error *ngIf="loginForm.get('password')?.hasError('required') && loginForm.get('password')?.touched">
                  Password is required.
                </mat-error>
                <mat-error *ngIf="loginForm.get('password')?.hasError('minlength')">
                  Password must be at least 8 characters.
                </mat-error>
                <mat-error *ngIf="loginForm.get('password')?.hasError('maxlength')">
                  Password cannot exceed 12 characters.
                </mat-error>
                <mat-error *ngIf="loginForm.get('password')?.hasError('pattern')">
                  Must include uppercase, lowercase, number, and special character.
                </mat-error>
                  <mat-error *ngIf="loginForm.get('password')?.hasError('backendError')">
                    {{ loginForm.get('password')?.getError('backendError') }}
                  </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Role Name</mat-label>
                <mat-select formControlName="roleName">
                  <mat-option *ngFor="let role of roles" [value]="role.value">{{ role.viewValue }}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-checkbox formControlName="isActive" color="primary">Active</mat-checkbox>

            </div>
          </div>
        </form>
      </mat-tab>

    </mat-tab-group>

    <!-- Save and Cancel Buttons (Outside Forms) -->
    <div class="form-actions" style="margin-top: 20px;">
      <button mat-flat-button color="primary" (click)="onSave()">
        Save
      </button>
      <button mat-flat-button color="warn" (click)="onCancel()">
        Cancel
      </button>
    </div>

  </mat-card-content>
  </mat-card>

  <div class="modal-overlay" *ngIf="showEndEmployeeModal">
<mat-card class="end-employment-dialog">
  <h3 mat-card-title>End Employment</h3>

  <mat-card-content class="mat-body-1">
    <p class="section-title">Transfer responsibilities from</p>
    <p class="employee-name">{{ employeeDetails?.firstName }} {{employeeDetails?.lastName}}</p>

    <div class="mt-16 d-flex justify-content-between align-items-center" style="margin-bottom: 12px;">
      <p class="section-title" style="margin-bottom: 0;">Transfer responsibilities to</p>

      <button mat-flat-button color="primary" (click)="onRegisterNewEmployeeClick()" class="text-sm">
        Add New Employee
      </button>
    </div>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Search & Select Employee</mat-label>
      <input type="text" placeholder="Search by Name" aria-label="Employee Search" matInput
        [formControl]="replacementEmployeeControl" [matAutocomplete]="auto">

      <mat-icon matSuffix>arrow_drop_down</mat-icon>

      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onEmployeeSelected($event)"
        [displayWith]="displayEmployeeName">
        <ng-container *ngIf="filteredEmployees | async as employees">
          <mat-option *ngFor="let emp of employees" [value]="emp.value">
            {{ emp.label }}
          </mat-option>
          <mat-option *ngIf="employees.length === 0" disabled>
            No employees found.
          </mat-option>
        </ng-container>
      </mat-autocomplete>
    </mat-form-field>
    <div class="mt-24">
      <p class="section-title">The following items will be updated/transferred:</p>
      <ul class="update-list">
        <li>Employee job cards will be moved to the selected Employee.</li>
        <li>Employee responsibility will be moved to the selected Employee.</li>
        <li>Employee assigned complaints will be moved to the selected Employee.</li>
        <li>Employee login will be **disabled** and will only have resident access (if applicable).</li>
      </ul>
    </div>
  </mat-card-content>

  <mat-card-actions align="end" class="dialog-actions d-flex gap-3 justify-content-end" style="padding-bottom: 0px;">
    <button mat-flat-button color="warn" (click)="onModalCancel()">
      CANCEL
    </button>

    <button mat-flat-button color="primary" (click)="onModalConfirm()" [disabled]="!selectedReplacementId">
      {{ selectedReplacementId === 'NEW_EMPLOYEE_ID' ? 'REGISTER' : 'TRANSFER' }}
    </button>
  </mat-card-actions>
</mat-card>
</div>